<template>
  <div v-if="isShowBindPhone" class="bind-phone-box show-flex-box-c show-flex-center" @click.self="clickClosePop()">
    <div class="bind-phone-total show-flex-box-r show-flex-center">
      <div class="bind-phone-all show-flex-box-c">
        <!-- X图标 -->
        <em @click.self="clickClosePop()"></em>
        <dl class="bind-phone-content show-flex-box-c">
          <dt class="select-bind-phone-way show-flex-box-r">
            <ul class="select-bind-phone-way-list show-flex-box-r">
              <li class="select-bind-phone-way-item  show-flex-box-c">
                <span>绑定手机号</span>
                <em></em>
              </li>
            </ul>
            <span @click.self="backLogin()">返回登录</span>
          </dt>
          <dd class="account-box show-flex-box-c">
            <div class="account-content-info show-flex-box-c">
              <ul class="account-content-password-input show-flex-box-c">
                <li class="show-flex-box-r">
                  <em></em>
                  <span class="show-flex-box-r">
                    <input type="text" placeholder="请输入手机" v-model="bindInfoFrom.account">
                  </span>
                </li>
                <li class="show-flex-box-r">
                  <em></em>
                  <span class="show-flex-box-r"> 
                    <input type="text" placeholder="请输入验证码" v-model="bindInfoFrom.verifiyCode">
                  </span>
                  <h3 class="show-flex-box-r" v-if="!countDownStatus">
                    <em></em>
                    <strong @click="!countDownStatus && verifyCodeCountDown()">获取验证码</strong>
                  </h3>
                   <h4 class="show-flex-box-r" v-else>
                    <em></em>
                    <strong>{{remainCount}}s</strong>
                  </h4>
                </li>
              </ul>
            </div>
            <span class="show-flex-box-r">
              <span @click="bindPhone()">绑定</span>
             </span>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
  import wx from 'weixin-js-sdk'
  import regex from "@/filter/regex";
  import { CountDown } from "@/../static/js/CountDown";
  // import {LoginUser} from "@/model/login_user.js";

  export default {
    name: "bind-phone",
    props: {
      bindParams: [Object]
    },
    data() {
      return {
        isShowBindPhone: false,
        remainCount:60,
        countDownStatus: false,
        counter: null,
        bindInfoFrom:{
          account:'',
          verifiyCode:'',
        },
    };
    },
    components: {},
    mounted() {
      this.initCountDown();
    },
    methods: {
      initCountDown: function() {
        this.counter = new CountDown(60, (cnt)=> {
          if (0 === cnt) {
            this.clearCounterWithCount();
          } else {
            this.remainCount = cnt;
          }
        });
      },
      clearCounterWithCount: function() {
        this.counter && this.counter.cancel();
        this.countDownStatus = false;
      },
      clickClosePop: function() {
        this.colseLoginWin(false);

        this.$emit('popShowStatusChange',{
          type: 'close',
          status: this.isSetPasswordLogin,
        });
      },
      colseLoginWin: function(isShow) {
        this.isShowBindPhone = typeof(isShow) != 'undefined' ? isShow : !this.isShowBindPhone;
      },
      bindPhone: function() {
        const phone = this.bindInfoFrom.account;
        const verifiyCode = this.bindInfoFrom.verifiyCode;
        const isPhone = regex.isPhoneNumber(phone);
        const hasVerifiyCode = regex.isEmpty(verifiyCode);
        let msg = '';

        if (!isPhone) {
          msg = '请输入正确的手机号';
        } else if (hasVerifiyCode) {
          msg = '请输入验证码';
        }

        if (msg) {
          this.$message({
            showClose: true,
            message: msg,
            type: "error"
          });
          return;
        }

        let bindData = this.bindParams;
        bindData.phone = phone;
        bindData.verify_code = verifiyCode;

        this.$client.socialBind(bindData)
        .then(res => {
          if (res.code == 200) {
            const curData = res.data;
            this.bindPhoneSuccess(curData);
          }
        })
        .catch(err => {
          this.$message({
            showClose: true,
            message: err.data.message,
            type: "error"
          });
        });
      },
      bindPhoneSuccess: function(bindData) {
        this.$message({
          showClose: true,
          message: "绑定成功",
          type: "success"
        });

        var token = bindData.token;
        var hasPwd = bindData.user ? !!bindData.user.has_password : false;
        var saveTokenObj = {
          token: token
        };

        this.$store.commit("SET_TOKEN", saveTokenObj);
        this.$store.commit("LOGIN", true); //登录成功后改变登录状态

        if (hasPwd) {
          this.$router.push({ path: "/web/index" });
          window.location.reload();
        } else {
          this.$emit("open-set-password-pop", false);
        }
      },
      verifyCodeCountDown: function() {
        const allowSend = this.checkCanVerify();
        if (allowSend) this.sendMessage();
      },
      checkCanVerify: function() {
        const account = this.bindInfoFrom.account;
        let status = true;
        let msg = regex.isEmpty(account) ? '请输入您的手机号' : !regex.isPhoneNumber(account) ? '请输入正确的手机号' : '';

        if (msg) {
          this.$message({
            showClose: true,
            message: msg,
            type: "error"
          });

          status = false;
        }

        return status;
      },
      sendMessage: function() {
        var params = {
          way: 'phone',
          account: this.bindInfoFrom.account,
          type: "bind_social"
        };

        this.$client.sendVerifyCode(params)
          .then(res => {
            if (res.code == 200) {
              this.$message({
                showClose: true,
                message: "验证码发送成功",
                type: "success"
              });

              this.countDownStatus = true;
              this.counter.start();
            }
          })
          .catch(err => {
            this.clearCounterWithCount();

            if (err.data && err.data.message) {
              this.$message({
                showClose: true,
                message: err.data.message,
                type: "error"
              });
            }
          });
      },
      backLogin: function() {
        this.colseLoginWin(false);
        
        this.$emit('popShowStatusChange',{
          type: 'backLogin',
          status: this.isSetPasswordLogin,
        });
      }
    }
  };

</script>
<style lang="less" scoped>
  .bind-phone-box{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    background: rgba(0, 0, 0, 0.4);
    .bind-phone-total{
      width:560px;
      padding: 30px 0px 60px 0px; 
      background:#FFFFFF;
      border-radius:8px;
      position: absolute;
      .bind-phone-all{
        width: 506px;
        height: 100%;
        align-items: flex-end;
        padding-left: 22px;
        >em{
          display: block;
          width: 22px;
          height: 22px;
          background: url("../../assets/login/close_arrow_icon.png") no-repeat center center;
          background-size: 22px 22px;
          margin-bottom: 18px;
          flex-shrink: 0;
          cursor: pointer;
        }
        >dl{
          width: 100%;
          >dt{
            padding-right: 23px;
            align-items: flex-end;
            margin-bottom: 30px;
            >ul{
              width: 100%;
              align-items: center;
              >li{
                align-items: center;
                margin-right: 25px;
                cursor: pointer;
                >span{
                  font-size:24px;
                  font-family:PingFangSC-Regular,PingFang SC;
                  font-weight:400;
                  color:#333333;
                  line-height:33px;
                  white-space: nowrap;
                  flex-shrink: 0;
                  margin-bottom: 5px;
                }
                >em{
                  width:35px;
                  height:5px;
                  background:#CB1309;
                  border-radius:3px;
                }
              }
            }
            >span{
              font-size:15px;
              font-family:PingFangSC-Regular,PingFang SC;
              font-weight:400;
              color:#333333;
              line-height:21px;
              white-space: nowrap;
              flex-shrink: 0;
              margin-bottom: 10px;
              cursor: pointer;
            }
          }
          .account-box{
            width: 100%;
            .account-content-info{
              padding-right: 23px;
              >h3{
                width: 100%;
                height:41px;
                background:rgba(203,19,9,0.06);
                border-radius:4px;
                border:1px solid #CB1309;
                margin-bottom: 20px;
                align-items: center;
                >em{
                  width: 13px;
                  height: 13px;
                  display: block;
                  background: url(../../assets/login/alret_icon.png) no-repeat center center;
                  background-size: 100% 100%;
                  flex-shrink: 0;
                  margin-left: 20px;
                }
                >span{
                  font-size:12px;
                  font-family:PingFangSC-Regular,PingFang SC;
                  font-weight:400;
                  color:#CB1309;
                  line-height:17px;
                  margin-left: 5px;
                }
              }
              .account-content-password-input{
                width: 100%;
                >li{
                  padding: 0px 15px;
                  height:60px;
                  background:#FAFAFA;
                  box-shadow:3px 3px 3px 0px #F4F4F9;
                  border-radius:4px;
                  border:1px solid #EEEEEF;
                  margin-bottom: 20px;
                  align-items: center;
                  cursor: pointer;
                  >em{
                    width: 20px;
                    height: 20px;
                    display: block;
                    background: url(../../assets/login/account_icon.png) no-repeat center center;
                    background-size: 100% 100%;
                    flex-shrink: 0;
                  }
                  >span{
                    flex-grow: 1;
                    margin-left: 20px;
                    align-items: center;
                    >input{
                      width: 100%;
                      height: 100%;
                      font-size:16px;
                      font-family:PingFangSC-Medium,PingFang SC;
                      font-weight:500;
                      color:#333333;
                      line-height:22px;
                    }
                  }
                  >strong{
                    font-size:12px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    color:#CB1309;
                    line-height:17px;
                    cursor: pointer;
                  }
                }
                >li:hover{
                  padding: 0px 15px;
                  height:60px;
                  background:rgba(203,19,9,0.04);
                  box-shadow:3px 3px 3px 0px rgba(203,19,9,0.1);
                  border-radius:4px;
                  border:1px solid rgba(203,19,9,1);
                }
                >li:nth-child(2){
                  >em{
                    width: 20px;
                    height: 20px;
                    display: block;
                    background: url(../../assets/login/verify_icon.png) no-repeat center center;
                    background-size: 100% 100%;
                    flex-shrink: 0;
                  }
                  >h3{
                    width: 80px;
                    padding-left: 15px;
                    height: 20px;
                    border-left: 1px #CB1309 solid;
                    flex-shrink: 0;
                    >em{
                      width: 15px;
                      height: 15px;
                      display: block;
                      background: url(../../assets/login/message_icon.png) no-repeat center center;
                      background-size: 100% 100%;
                      flex-shrink: 0;
                      margin-top: 3px;
                    }
                    >strong{
                      font-size:12px;
                      font-family:PingFangSC-Regular,PingFang SC;
                      font-weight:400;
                      color:#CB1309;
                      line-height:20px;
                      margin-left: 5px;
                      cursor: pointer;
                    }
                  }
                  >h4{
                    width: 60px;
                    padding-left: 35px;
                    height: 20px;
                    border-left: 1px #CB1309 solid;
                    flex-shrink: 0;
                    cursor: default;
                    >em{
                      width: 15px;
                      height: 15px;
                      display: block;
                      background: url(../../assets/login/gray_message_icon.png) no-repeat center center;
                      background-size: 100% 100%;
                      flex-shrink: 0;
                      margin-top: 3px;
                    }
                    >strong{
                      font-size:12px;
                      font-family:PingFangSC-Regular,PingFang SC;
                      font-weight:400;
                      color:#CCCCCC;
                      line-height:20px;
                      margin-left: 5px;
                    }
                  }

                }
              }
              
            }
            >span{
              padding-right: 23px;
              margin-top: 10px;
              >span{
                cursor: pointer;
                width: 100%;
                height:60px;
                background:#CB1309;
                box-shadow:0px 2px 4px 0px #CB1309;
                border-radius:4px;
                line-height: 60px;
                text-align: center;
                font-size:16px;
                font-family:PingFangSC-Medium,PingFang SC;
                font-weight:500;
                color:rgba(255,255,255,1);
              }
              
            }
          }
        }
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/views/login/bind_phone.vue